import { render, staticRenderFns } from "./EventCountdown.vue?vue&type=template&id=e8d182fa&scoped=true&"
import script from "./EventCountdown.vue?vue&type=script&lang=js&"
export * from "./EventCountdown.vue?vue&type=script&lang=js&"
import style0 from "./EventCountdown.vue?vue&type=style&index=0&id=e8d182fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d182fa",
  null
  
)

export default component.exports